import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './app.jsx';
import './index.css';
import { initPostHog } from './lib/posthog.js';

initPostHog();

// After a production deploy, the browser holds stale chunk URLs (Vite
// hashes change on every build). Lazy route imports then fail with
// "Failed to fetch dynamically imported module" and React Router surfaces
// the "Unexpected Application Error" screen. A one-shot hard reload picks
// up the fresh index.html + new chunk hashes. The sessionStorage guard
// prevents a loop if the real network is broken.
//
// Gated on production: in dev Vite itself handles HMR + preload retries,
// and its transient warmup errors would otherwise trick this handler into
// reloading on every cold start.
if (import.meta.env.PROD) {
  const RELOAD_FLAG = 'cirun:reloaded-for-stale-chunk';
  const reloadOnStaleChunk = (message) => {
    if (!/Failed to fetch dynamically imported module|Importing a module script failed/.test(message)) {
      return false;
    }
    if (sessionStorage.getItem(RELOAD_FLAG)) return false;
    sessionStorage.setItem(RELOAD_FLAG, '1');
    window.location.reload();
    return true;
  };
  window.addEventListener('vite:preloadError', (event) => {
    if (reloadOnStaleChunk(event.payload?.message ?? '')) event.preventDefault();
  });
  window.addEventListener('unhandledrejection', (event) => {
    reloadOnStaleChunk(event.reason?.message ?? '');
  });
}

const root = document.getElementById('root');
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
